module.exports = __webpack_public_path__ + "static/media/1.dc44c3be.jpg";